// extracted by mini-css-extract-plugin
export default {"randomCardContainer":"RandomCards_randomCardContainer__YQ4uS","randomCard":"RandomCards_randomCard__T-cGd","randomCardImage":"RandomCards_randomCardImage__ydZQ5"};